import axios from 'axios';

const ODSOrganisationsEndpointUrl =
    'https://directory.spineservices.nhs.uk/ORD/2-0-0/organisations';

function getOrganisation(orgCode) {
    return axios
        .get(`https://directory.spineservices.nhs.uk/ORD/2-0-0/organisations/${orgCode}`)
        .then(response => {
            if (response?.status === 200) {
                return response?.data?.Organisation;
            }
            return undefined;
        })
        .catch(error => {});
}

async function getOrganisationPostCode(orgCode) {
    const organisation = await getOrganisation(orgCode);

    return organisation?.GeoLoc?.Location?.PostCode;
}

async function getBranchSites(orgCode) {
    const response = await axios.get(
        `https://directory.spineservices.nhs.uk/ORD/2-0-0/organisations?RelTypeId=RE6&TargetOrgId=${orgCode}`
    );

    return response.data.Organisations;
}

const searchByPrimaryRoleIdAndName = async (roleId, name) => {
    var orgs = await axios.get(
        `${ODSOrganisationsEndpointUrl}?PrimaryRoleId=${roleId}&Name=${name}`
    );
    if (orgs.data.Organisations.length > 0) {
        return orgs;
    } else {
        const org = await axios.get(`${ODSOrganisationsEndpointUrl}/${name}`);
        orgs.data.Organisations.push(org);
        return org;
    }
};

async function getOrganisationType(orgCode) {
    const response = await axios.get(
        `https://directory.spineservices.nhs.uk/ORD/2-0-0/organisations/${orgCode}`
    );

    const roles = response.data.Organisation.Roles.Role;
    const primaryRole = roles.find(role => role.primaryRole === true);
    const primaryRoleId = primaryRole ? primaryRole.id : roles[0].id;

    return primaryRoleId;
}

export {
    getOrganisation,
    getOrganisationPostCode,
    getBranchSites,
    searchByPrimaryRoleIdAndName,
    getOrganisationType
};
